import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const alfanum = /[A-Za-z0-9]/;

const masks = {
  cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  cpfFiltroExigencia: [/\w/, /\w/, /\w/, '.', /\w/, /\w/, /\w/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  /*
  cnpj: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  */
  cnpj: [alfanum, alfanum, '.', alfanum, alfanum, alfanum, '.', alfanum, alfanum, alfanum, '/', alfanum, alfanum, alfanum, alfanum, '-', alfanum, alfanum],
  date: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  nit: [/\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/],
  competencia: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  cep: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  telefoneMovel: ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  telefoneFixo: ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  compet: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  integer: createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: false,
  }),
  currency: createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
  }),
  participation: createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 8,
  }),
  dateCorrect: createAutoCorrectedDatePipe('dd/mm/yyyy'),
  competenciaCorrect: createAutoCorrectedDatePipe('mm/yyyy'),
};

export default masks;



// WEBPACK FOOTER //
// ./src/utils/masks.js